// extracted by mini-css-extract-plugin
export default {"ns_label_error_notifier_text":"NSLabelErrorNotifier_ns_label_error_notifier_text__tyx7U"};